import { toJS, makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {types, endpoints} from 'main/tools';
import {formatFilterDates} from 'main/containers/reports/tools';
import ReportDownload from 'main/stores/reports/ReportDownload';

const POLL_INTERVAL = 2000;

class ReportDownloadState {
  downloadUrl;
  filters;
  interval;
  store = new DomainStore();

  modalOpen = false;
  pending = true;
  reportDownload = null;
  selectedFileType = 'csv';

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({downloadUrl, filters}) {
    this.downloadUrl = `${downloadUrl}/download`;
    this.filters = filters;
  }

  closeModal() {
    this.modalOpen = false;
  }

  async requestDownload(fileType = this.selectedFileType) {
    clearInterval(this.interval);

    this.selectedFileType = fileType;

    await this.postDownloadRequest();
    this.startPolling();
    this.modalOpen = true;
  }

  async postDownloadRequest() {
    this.filters.exportType = this.selectedFileType;
    this.pending = true;
    const {model} = await this.store.post(
      this.downloadUrl,
      types.REPORT_DOWNLOAD,
      {
        reportDownloadParams: toJS(formatFilterDates(this.filters))
      }
    );

    this.reportDownload = model;
  }

  async poll() {
    const endpoint = endpoints.REPORT_DOWNLOAD.with(this.reportDownload.id);
    const response = (await this.store._compose([endpoint]))[0];
    this.reportDownload = new ReportDownload(response.data);

    if (this.reportDownload.isReady) {
      clearInterval(this.interval);
      this.pending = false;
    }
  }

  startPolling() {
    this.interval = setInterval(() => this.poll(), POLL_INTERVAL);
  }
}

export default ReportDownloadState;
